import React, {ClipboardEvent, useEffect, useState} from 'react';

import { rootActions, useAppDispatch, useAppSelector } from '../DAL/store';
import DebugScreenForms from "../components/debug-screen";
import {getForm, getSectionClass, setForm} from "../DAL/data-service";
import {
    createControl,
    validateControl
} from "../../../domain/validation/validation";
import FormTextField from "../../../ui/forms/fields/text-field";
import {IFormControl} from "../../../ui/forms/interfaces";

import {
    getRecaptcha2Error,
    getRecaptchaToken,
    renderRecaptcha2,
    resetRecaptcha2
} from "../../../domain/captcha/recaptcha-provider";

import ChinaCaptchaField from "../../../ui/forms/fields/captcha-china-field";
import Recaptcha3Text from "../../../domain/captcha/recaptcha3-terms";
import {
    FormAfterSubmitType,
    FormComponentDM,
    FormConfiguration,
    FormSendWrapper,
    SelectReactSources
} from "../interfaces";
import {cloneDeep} from "lodash";
import FormTextAreaField from "../../../ui/forms/fields/textarea-field";
import SelectReactField from "../../../ui/forms/fields/select-react-field";
import {IValidationRules} from "../../../domain/validation/interfaces";
import FormCheckboxField from "../../../ui/forms/fields/checkbox-field";
import {ProcessResultType} from "../../../domain/process-result/interfaces";
import {getSimpleCaptchaValidationError} from "../../../domain/captcha/simple-captcha";
import {getIsChina} from "../../../domain/hidden-data-provider";

interface IFormsProps {
    formType?: string | null
}
/**
 * the entry point
 */
const FormsApp= (props:IFormsProps) => {

    const [isLoading, setIsLoading] = useState(false);
    // test -----------
    const dispatch = useAppDispatch();
    const isDebug = useAppSelector((store) => store.isDebug);
    const firstLoad = useAppSelector((store) => store.firstLoad);
    const pResult = useAppSelector((store) => store.pResult);
    const formConfiguration = useAppSelector((store) => store.formConfiguration);
    const formComponentList = useAppSelector((store) => store.formComponentList);
    const formSettings = useAppSelector((store) => store.formSettings);
    const resultMessageShow = useAppSelector((store) => store.resultMessageShow);

    let FormControls = [] as any[];
    const [customControlList, setCustomControlList] = useState<any>();
    const [selectReactSources, setSelectReactSources] = useState<SelectReactSources[]>();
    const [IsValidForm, setIsValidForm] = useState<boolean>(true);


    /*----------------------------------------------------------------------Recaptcha*/
    const isChina = getIsChina();

    const simpleCaptchaControl = createControl('simpleCaptcha', '', {
        required: true,
        requiredMessage: getSimpleCaptchaValidationError(),
        length: 5,
    });
    // simple captcha - used for china
    const [simpleCaptchaCode, setSimpleCaptchaCode] = useState<IFormControl>(simpleCaptchaControl);
    const [simpleCaptchaAttempts, setSimpleCaptchaAttempts] = useState(0);

    // google recaptcha version 2 & 3
    const [recaptchaVersion, setRecaptchaVersion] = useState(3);
    const [recaptcha2WidgetID, setRecaptcha2WidgetID] = useState(0);

    // captcha: common
    const [captchaError, setCaptchaError] = useState('');

    /**
     * load initial data (drop-downs content) on page load once
     */
    useEffect(() => {
        (async () => {
            if(!props?.formType)
                return;
            setIsLoading(true);
            const response = await getForm(props?.formType);
            setIsLoading(false);
            if(firstLoad) {
                dispatch(
                    rootActions.main({
                        pResult: response.data.pResult,
                        formComponentList: response.data.formComponentList,
                        formConfiguration: response.data.formConfiguration,
                        formSettings: response.data.formSettings,
                        firstLoad: false
                    })
                );
                createControlList(response.data.formConfiguration);
                //IsValidFormCheck();
            }

        })();
    }, []);
    const createControlList = async (formConfiguration:FormConfiguration) => {

        if(formConfiguration.editableAreas.length === 0)
            return;

        const _selectReactSources:SelectReactSources[] =[] ;
        formConfiguration.editableAreas.forEach(function(area, i, arrA) {
            area.sections.forEach(function(section, y, arrS) {
                section.zones.forEach(function(zone, z, arrZ) {
                    zone.formComponentList.forEach(function(fc, f, arrF) {
                        //console.log('createControlList: ',fc);

                        let defVal:any = fc.defaultValue;
                        if(fc.propertiesType === 'DropDownProperties') {
                            defVal = fc.dataSource[0];
                            _selectReactSources.push({id: fc.name, dataSource: fc.dataSource});
                        }

                        let rules:IValidationRules =
                            {
                                required: fc.required,
                                name: fc.explanationText?.includes('safe-text'),
                                email: fc.explanationText?.includes('email'),
                                phone:fc.explanationText?.includes('phone')
                            };
                        //console.log('rules: ',rules);
                        if(fc.propertiesType === 'DropDownProperties') {
                            rules = {
                                required: (currentControl) => {
                                    //console.log('required: ',currentControl);
                                    if(!currentControl) return false;

                                    const current = currentControl.value;
                                    if(!current) return false;

                                    return current.value !== '';
                                }
                            }
                        }

                        let customControl = createControl('control-'+fc.name, defVal, rules);
                        FormControls.push(customControl);
                    });

                });
            });
        });
        setCustomControlList(FormControls);
        setSelectReactSources(_selectReactSources);
    }
    const IsValidFormCheck = ()=> {
        let isFormValid = true;
        if(!customControlList || customControlList?.length  === 0)
            return isFormValid;

        for(let index = 0; index < customControlList.length; index++){
            let HTML_element = document.getElementById(customControlList[index].id);
            //console.log('IsValidForm: ',customControlList[index]);
            if(HTML_element !== null){
                // if the element is not hidden
                let updatedControl = validateControl(customControlList[index]) as IFormControl;
                //let updatedControl  = updateControl(customControlList[index],customControlList[index].value, true);
                //console.log('updatedControl: ',updatedControl);
                customControlList[index] = updatedControl;
                if(!updatedControl.isValid){
                    isFormValid = false;
                }
            }

        }

        setIsValidForm(isFormValid);
        return isFormValid;
    }
    const clearMessage = ()=> {
        dispatch(
            rootActions.main({
                resultMessageShow: false
            })
        );
    }
    const IsValidControlCheckAndUpdate = (controlToCheck: IFormControl)=> {
        let isValid = true;

        let HTML_element = document.getElementById(controlToCheck.id);
        console.log('IsValidControlCheckAndUpdate: ',HTML_element);
        if(HTML_element !== null){
            // if the element is not hidden
            let updatedControl = validateControl(controlToCheck) as IFormControl;
            handleChangeEvent(updatedControl);
            if(!updatedControl.isValid){
                isValid = false;
            }
        }

        setIsValidForm(isValid);
        //console.log('IsValidControlCheckAndUpdate: ',customControlList);
        //return isFormValid;
    }
    const handleChangeEvent = (controlUpd: IFormControl) => {
        //console.log(`handleChangeEvent: `,controlUpd);
        let controlList = cloneDeep(customControlList);
        for(let index = 0; index < controlList.length; index++){
            if(controlList[index].id === controlUpd.id){
                controlList[index].value = controlUpd.value;
                controlList[index].isValid = controlUpd.isValid;
                controlList[index].error = controlUpd.error;
            }
        }
        setCustomControlList(controlList);

    };
    const clearForm = () => {

        let controlList = cloneDeep(customControlList);
        for(let index = 0; index < controlList.length; index++){
            console.log('clearForm: ',controlList[index]);
            const find = formComponentList.filter(fc=> 'control-' + fc.name === controlList[index].id)
            if(find &&find.length === 1){

                if(find[0].propertiesType === 'DropDownProperties') {
                    controlList[index].value = find[0].dataSource[0];
                }
                else
                    controlList[index].value = find[0].defaultValue;
            }
        };
        setCustomControlList(controlList);
        simpleCaptchaCode.value = '';
        setSimpleCaptchaCode(simpleCaptchaCode);
    };
    const sendData = async () => {
        if(!props.formType)
            return;
        if(!IsValidFormCheck())
            return;

        const captchaToken = !isChina ? await getRecaptchaToken(recaptchaVersion) : simpleCaptchaCode.value;

        if(!captchaToken){
            setCaptchaError(isChina ? getSimpleCaptchaValidationError() : getRecaptcha2Error());
            setIsLoading(false);
            return;
        }

        let controlList = cloneDeep(customControlList);
        let formComponentListClone = cloneDeep(formComponentList) as FormComponentDM [];

        //console.log('controlList: ',controlList);
        //console.log('formComponentListClone: ',formComponentListClone);

        formComponentListClone.forEach(function(fc, f, arrF) {
            for(let index = 0; index < controlList.length; index++){
                if(controlList[index].id === 'control-' + fc.name){
                    if(fc.propertiesType === 'DropDownProperties')
                        fc.valueToSave = controlList[index].value.value;
                    else
                        fc.valueToSave = controlList[index].value;
                }
            }
        });

        let sendForm:FormSendWrapper = {
            formComponentList:  formComponentListClone,
            formName:  "",
            captchaCode: captchaToken,
            recaptchaVersion: recaptchaVersion,
        }

        setIsLoading(true);
        const response = await setForm(sendForm, props?.formType);
        console.log('response: ',response);
        setIsLoading(false);

        if(!response || response.statusCode !== 200) {
            //setError(response.data as unknown as ModelServerErrors);
            return;
        }

        if(response.data.pResult.result === ProcessResultType.Success){

            if(formSettings.formAfterSubmit === FormAfterSubmitType.ReloadForm){
                window.location.reload();
                return;
            }
            if(formSettings.formAfterSubmit === FormAfterSubmitType.RedirectToUrl){
                window.location.href = formSettings.formRedirectToUrl;
                return;
            }
            clearForm();

        }


        dispatch(
            rootActions.main({
                pResult: response.data.pResult,
                resultMessageShow: true
            })
        );
        //------------------------------------------------------------------------recaptcha-error
        if(isChina){

            // re-render simple captcha
            setSimpleCaptchaAttempts(simpleCaptchaAttempts + 1);
        }
        else{
            if(response?.data.ResultEXType === 'recaptcha-error') {
                setRecaptchaVersion(2);
                renderCaptcha2Fallback();
            }

            if(recaptchaVersion === 2){
                resetRecaptcha2();
            }
        }

    };
    /**
     * if recaptcha 3 returns low score (the limit is defined in kentico settings),
     * then recaptcha 2 fallback should be rendered inside <div id="recaptcha"></div>
     */
    const renderCaptcha2Fallback = () => {
        if(!window.grecaptcha) return;

        window.grecaptcha.ready(async () => {
            const widgetID = await renderRecaptcha2('recaptcha');
            setRecaptcha2WidgetID(widgetID);
        });
    };
    return (
        <>
            {
                    <div>
                        {/*Debug Screen section---------------------------------------------------------------------------------------------*/}
                        {isDebug && <DebugScreenForms />}
                        {isDebug && <div className="">formType:{props.formType}</div>}
                        {isDebug && <div className="">firstLoad:{firstLoad.toString()}</div>}
                        {isDebug && <button type="button" className="w-btn p-4 w-44 mb-4"
                                onClick={evt => {
                                    IsValidFormCheck();
                                }}>Check Valid: {IsValidForm.toString()}</button>}

                        {/*Form fields section---------------------------------------------------------------------------------------------*/}
                        {!firstLoad && formConfiguration.editableAreas.length > 0 && customControlList?.length > 0 &&
                            formConfiguration.editableAreas.map((area, i) => {
                                return (
                                    <div key={'area-'+i} className={`area-${i}`}>{
                                        area.sections.map((section, s) => {
                                            return (
                                                <div key={'section-'+s} className={`section-${s} ${getSectionClass(section.typeIdentifier)}`}>
                                                    {
                                                        section.zones.map((zone, z) => {
                                                            return (
                                                                <div key={'zone-'+z}  className={`zone-${z} w-full`}>

                                                                    {
                                                                        zone.formComponentList.map((comp, f) => {
                                                                            let control = customControlList.filter((contr:any) => contr.id === 'control-' + comp.name)[0];
                                                                            switch (comp.propertiesType) {
                                                                                case "TextInputProperties":
                                                                                    //console.log('TextInputProperties control: ',control);
                                                                                    return(
                                                                                        /*<div key={'fc-'+f}>TextBOx</div>*/
                                                                                        <FormTextField
                                                                                            key={ 'txt-' + comp.name }
                                                                                            id={ 'control-' + comp.name }
                                                                                            label={ comp.label}
                                                                                            control={ control }

                                                                                            maxLength={ comp.size }
                                                                                            onChange={ evt => {
                                                                                                const $target = evt.target as HTMLInputElement;
                                                                                                //console.log('onChange: ',$target);
                                                                                                control.value = $target.value;
                                                                                                //handleChangeEvent(control);
                                                                                                IsValidControlCheckAndUpdate(control);
                                                                                            }}
                                                                                            onBlur={ evt => {
                                                                                                IsValidControlCheckAndUpdate(control);
                                                                                            }}
                                                                                            onClick={ clearMessage }
                                                                                            onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                                                                                                //setFirstName(updateControl(firstName, removeInvisibleCharsOnPaste(evt)));
                                                                                            }}
                                                                                        />

                                                                                    )
                                                                                case "TextAreaProperties":
                                                                                    return(
                                                                                        <FormTextAreaField
                                                                                        key={ 'txt-' + comp.name }
                                                                                        id={ 'control-' + comp.name }
                                                                                        label={ comp.label}
                                                                                        control={ control }
                                                                                        maxLength={ 524288 }
                                                                                        cols={4}
                                                                                        rows={7}
                                                                                        focus={ false }
                                                                                        onChange={ evt => {
                                                                                            const $target = evt.target as HTMLInputElement;
                                                                                            //console.log('TextArea');
                                                                                            control.value = $target.value;
                                                                                            //handleChangeEvent(control);
                                                                                            IsValidControlCheckAndUpdate(control);

                                                                                        }}
                                                                                        onClick={ clearMessage }
                                                                                        onBlur={ evt => {
                                                                                            IsValidControlCheckAndUpdate(control);
                                                                                        }}
                                                                                    />)
                                                                                case "CheckBoxProperties":
                                                                                    return(
                                                                                        <FormCheckboxField
                                                                                            key={ 'chk-' + comp.name }
                                                                                            id={ 'control-' + comp.name }
                                                                                            label={ comp.label}
                                                                                            isChecked={ control.value }
                                                                                            onChange={ () => {
                                                                                                control.value = !control.value;
                                                                                                handleChangeEvent(control);
                                                                                            }}
                                                                                            onClick={ clearMessage }
                                                                                        />
                                                                                    )
                                                                                case "HtmlCodeFormComponentProperties":
                                                                                    return(
                                                                                        <div className={""} dangerouslySetInnerHTML={{ __html: comp.defaultValue }} />
                                                                                    )
                                                                                case "DropDownProperties":
                                                                                    const dataSource = selectReactSources?.filter(f=>f.id === comp.name)[0].dataSource;
                                                                                    return(
                                                                                        <SelectReactField
                                                                                            key={ 'ddl-' + comp.name }
                                                                                            idPrefix={ 'control-' + comp.name }
                                                                                            onChange={
                                                                                                (option) => {
                                                                                                    //console.log(option);
                                                                                                    control.value = option;
                                                                                                    handleChangeEvent(control);
                                                                                                    //setResponse(null); // empty server error
                                                                                                    //setCaptchaError('');
                                                                                                }
                                                                                            }
                                                                                            onBlur={ (option) => {
                                                                                                IsValidControlCheckAndUpdate(control);
                                                                                            }}
                                                                                            label={comp.label}
                                                                                            options={dataSource}
                                                                                            selectIdControl={control}
                                                                                        />)
                                                                                default:
                                                                                    return (
                                                                                        <div key={'fc-'+f} className="border border-gray-500">
                                                                                            <div>name:{ comp.name}</div>
                                                                                            <div>dataType:{ comp.dataType}</div>
                                                                                            <div>defaultValue:{ comp.defaultValue}</div>
                                                                                            <div>label:{ comp.label}</div>
                                                                                            <div>explanationText:{ comp.explanationText}</div>
                                                                                            <div>propertiesType:{ comp.propertiesType}</div>
                                                                                            <div>required:{ comp.required.toString()}</div>
                                                                                            <div>visible:{ comp.visible}</div>
                                                                                            <div>size:{ comp.size}</div>
                                                                                            <div>tooltip:{ comp.tooltip}</div>
                                                                                        </div>
                                                                                    );
                                                                            }

                                                                        })
                                                                    }
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            );
                                        })
                                    }</div>
                                );
                            })
                        }
                        {
                            /* ------------- google recaptcha version 2 or 3 ------------- */
                            !isChina &&
                            <div id="recaptcha" className={`mb-4 flex justify-center recaptcha recaptcha-version-${ recaptchaVersion }`}/>
                        }

                        {
                            /* ------------- china simple captcha ------------- */
                            isChina &&
                            <div className="w-64 mx-2">
                            <ChinaCaptchaField
                                control={ simpleCaptchaCode }
                                setSimpleCaptchaCode={ setSimpleCaptchaCode }
                                simpleCaptchaAttempts={ simpleCaptchaAttempts }
                            />
                            </div>
                        }
                        {
                            captchaError &&
                            <div className="text-sm text-red my-4 text-center" data-id={ recaptcha2WidgetID }>{ captchaError }</div>
                        }
                        {/*Button section---------------------------------------------------------------------------------------------*/}
                        { formConfiguration.editableAreas.length > 0 && customControlList?.length > 0 && !isLoading && IsValidForm &&
                            <button type="button" className="w-btn w-min"
                                    onClick={evt => {
                                        sendData();
                                    }}>{formSettings.formSubmitButtonText}</button>}

                        { formConfiguration.editableAreas.length > 0 && customControlList?.length > 0 && (!IsValidForm || isLoading) &&
                            <button type="button" className="w-btn w-min bg-gray-400"
                            >{!isLoading ? formSettings.formSubmitButtonText : "Sending..."}</button>}

                        {/*Message-Box section---------------------------------------------------------------------------------------------*/}
                        {
                            pResult.result === ProcessResultType.Fail
                            && resultMessageShow
                            && pResult.message !== null
                            && <div className="mt-8 error-box" role="alert"><div dangerouslySetInnerHTML={{ __html: pResult.message }} /></div>
                        }
                        {
                            pResult.result === ProcessResultType.Success
                            && resultMessageShow
                            && formSettings.formAfterSubmit === FormAfterSubmitType.DisplayText
                            && <div className="mt-8" role="alert" dangerouslySetInnerHTML={{ __html: formSettings.formDisplayText }} />
                        }
                        {
                            !isChina && recaptchaVersion === 3 &&
                            <div className="my-4 mx-2">
                                <Recaptcha3Text />
                            </div>
                        }
                    </div>
            }

        </>
    )
};

export default FormsApp;